import React from 'react';
import PropTypes from 'prop-types';
// import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { getTitleOrEmpty } from 'shared/helpers/common';
// import { intlShape } from 'react-intl';
import { withTranslate } from 'shared/hocs/withTranslate';

import { setNextSearchItemIndex } from 'shared/actions/history';
import TransportGridDetails from 'shared/components/TransportGridDetails/TransportGridDetails';

import { getDefaultImageByType } from 'shared/constants/defaultImages';
import { cleanArray } from 'shared/helpers/arrays';
import Link from 'shared/components/Link';

// import { getDrivenFromTitle } from 'shared/helpers/advert';

// import LeasingButtonWrapper from 'shared/components/LeasingOnlineBanner/LeasingButtonWrapper/LeasingButtonWrapper';

import SuggestButton from 'shared/components/SuggestForDefaultAd/SuggestButton/SuggestButton';

import withPixelRatio from 'shared/hocs/withPixelRatio';

// import carDefault from 'shared/assets/images/car-default.png';

import Thumb from '../Thumb/Thumb';
// eslint-disable-next-line css-modules/no-unused-class
import s from './CarDefaultItem.css';

const PER_PAGE = 20;

class CarLeasingItem extends React.Component {
  static propTypes = {
    car: PropTypes.shape().isRequired,
    // singleUpdatePackage: PropTypes.shape(),
    // isPreview: PropTypes.bool,
    // isProfile: PropTypes.bool,
    currentPage: PropTypes.number,
    index: PropTypes.number,
    setNextSearchItemIndex: PropTypes.func.isRequired,
    // onOpenRemoveModalClick: PropTypes.func.isRequired,
    // onOpenRemoveModalSupportClick: PropTypes.func.isRequired,
    // setRatioImage: PropTypes.func.isRequired,
    // editLink: PropTypes.string,
    width: PropTypes.number,
    // title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    // t: PropTypes.func.isRequired,
    // locale: PropTypes.string.isRequired,
    // token: PropTypes.string.isRequired,
    // handleSingleUpdate: PropTypes.func,
    //
    // intl: intlShape.isRequired,
  };
  static defaultProps = {
    singleUpdatePackage: null,
    handleSingleUpdate: () => {},
    onOpenRemoveModalClick: () => {},
    editLink: '/',
    onOpenRemoveModalSupportClick: () => {},
    isPreview: false,
    isProfile: false,
    currentPage: null,
    index: null,
    width: 220,
    title: '',
  };

  state = {
    showLeasingDialog: false,
  };

  handleLinkClick = () => {
    const { currentPage, index } = this.props;

    if (currentPage && Number.isInteger(index)) {
      const nextIndex = (currentPage - 1) * PER_PAGE + (index + 1) + 1;
      this.props.setNextSearchItemIndex(nextIndex);
    }
  };

  toggleModal = () => {
    this.setState({ showLeasingDialog: !this.state.showLeasingDialog });
  };

  renderCarTitle = advert =>
    cleanArray([
      getTitleOrEmpty(advert.make) || advert.make_title,
      getTitleOrEmpty(advert.model) || advert.model_title,
      getTitleOrEmpty(advert.modification),
      getTitleOrEmpty(advert.equipment),
    ]).join(' ');

  render() {
    const { car, width, index } = this.props;
    const { transport, photos } = car;

    const defaultImg = getDefaultImageByType(transport) || null;

    // const drivenFromTitle = getDrivenFromTitle(drivenFrom, t);
    // const imgAlt = '';

    const carTitle = this.renderCarTitle(car);
    const style = { width };
    return (
      <React.Fragment>
        <div className={s.root}>
          <div className={s.wrapper}>
            <div className={s.photos} style={style}>
              <Thumb key={Math.random()} width={width} photos={photos} defaultImg={defaultImg} />
              {/* <img src={carDefault} alt={carTitle} height={170} /> */}
            </div>
            <div className={s.conteiner}>
              <div className={s.details}>
                <div className={s.detailsLeft}>
                  <div className={s.title}>{carTitle}</div>
                  <div className={s.technical}>
                    <TransportGridDetails advert={car} />
                  </div>
                </div>
                <div className={s.detailsRight}>
                  <SuggestButton
                    advert={car}
                    index={index}
                    // useToolTip
                    showModal={this.state.showLeasingDialog}
                    toggleModal={this.toggleModal}
                  />
                </div>
              </div>
            </div>
            <Link onClick={this.toggleModal} className={s.stretchedLink}>
              <span />
            </Link>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ globals, user }) => ({
  locale: globals.locale,
  token: user && user.token,
});

const mapDispatchToProps = {
  setNextSearchItemIndex,
};

export default withStyles(s)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withPixelRatio(withTranslate(CarLeasingItem))),
);



// WEBPACK FOOTER //
// ./src/desktop/components/CarDefaultItem/CarDefaultItem.js